import { isProd, CustomStorage } from "../utils/storage";

import { AmplitudeClient } from "amplitude-js";

import Cookies from "js-cookie";

class ABTest {
	public key: string;
	public availableFor: number;
	public name: string;
	private storage = new CustomStorage();

	public setAvailability(available: boolean): void {
		const key = this.getStorageKey();
		const value = this.availableFor + (available ? -0.1 : 0.1);
		this.storage.setItem(key, value.toString());
	}

	constructor(key: string, availableFor: number, name: string) {
		this.key = key;
		this.availableFor = availableFor;
		this.name = name;
	}

	private getStorageKey(): string {
		return `${this.key.toLocaleLowerCase()}_rf`;
	}

	private getExpRandomFactor(): number {
		const key = this.getStorageKey();
		if (this.storage.getItem(key)) {
			return +this.storage.getItem(key)!;
		}
		this.storage.setItem(key, Math.random().toFixed(2).toString());

		return +this.storage.getItem(key)!;
	}

	public isAvailable(): boolean {
		return this.getExpRandomFactor() <= this.availableFor;
	}
}

class MultiTest {
	public key: string;
	public name: string;
	public variants: string[];

	private storage = new CustomStorage();

	constructor(key: string, variants: string[], name: string) {
		this.key = key;
		this.variants = variants;
		this.name = name;
	}

	private getStorageKey(): string {
		return `${this.key.toLocaleLowerCase()}_rf`;
	}

	private getExpRandomFactor(): number {
		const key = this.getStorageKey();
		if (this.storage.getItem(key)) {
			return +this.storage.getItem(key)!;
		}
		this.storage.setItem(key, Math.random().toFixed(2).toString());

		return +this.storage.getItem(key)!;
	}

	// return variant associated with user as a integer
	public getVariant(): number {
		const factor = 1 / this.variants.length;

		for (let i = 0; i < this.variants.length; i++) {
			if (i * factor <= this.getExpRandomFactor() && this.getExpRandomFactor() < (i + 1) * factor) {
				return i;
			}
		}

		return -1;
	}
}

export const assignUserToAbTest = (abTest: ABTest, amplitudeInstance: AmplitudeClient) => {
	if (isProd()) {
		amplitudeInstance.setUserProperties({
			[`abTest${abTest.key.charAt(0).toUpperCase()}${abTest.key.slice(1)}`]: abTest.isAvailable() ? "Variant" : "Control",
		});
	}
};

export const abTests = {
	askWhenWantToJoinTheCourse: new ABTest(
		"askWhenWantToJoinTheCourse",
		0.7,
		'Tela com pergunta "Quando deseja ingressar na faculdade... no Busca nota',
	),
	canaryAPI: new ABTest("canaryAPI8421", 0, "Canary API"),
	checkoutCouponField: new ABTest("checkoutCouponField", 0, "Campo de cupom na tela de checkout"),
	eligibilityRules: new ABTest("eligibilityRules", 0.5, "Mostrar no FAQ 'Quem não pode ter essa bolsa Amigo Edu?'"),
	enaeDatesLayout: new ABTest("enaeDatesLayout", 0.9, "Mostra o layout novo ou o antigo do componente das datas"),
	enaeHeadline: new ABTest("enaeHeadline", 0, "Outros textos para headline ENAE"),
	enaeNewHeadlineSimulado: new ABTest("enaeSimulado", 0, "ENAE - h1 usando simulado ao invés de pré-enem"),
	enaePostTestDay: new ABTest("enaePostTestDay", 0, "Página de aguardando resultado - ENAE"),
	enaeResultDay: new ABTest("enaeResultDay", 1, "Dia de divulgação dos resultados - ENAE"),
	headlineScholarshipDuration: new ABTest("headlineScholarshipDuration", 0.5, "h1 na home citando bolsa até o final do curso"),
	guaranteedChargeback: new ABTest("guaranteedChargeback", 0.5, "Mostrar aviso de reembolso garantido"),
	enaeTestDay: new ABTest("enaeTestDay", 0, "Dia de prova ENAE"),
	showStudentPhoto: new ABTest("showStudentPhoto", 0, "Foto de bolsista na home"),
	showInstitutionFilterHome: new ABTest("abTestInstitutionFilterHome2", 1, "Filtro de IES na home"),
	explainBenefitsCard: new ABTest("explainBenefitsCard", 0.5, "Card com explicação dos benefícios na busca de ofertas"),
	testAbCpVariant: new ABTest("testAbCpVariant", 0.5, "Teste de CP variante"),
	showVideoInHome: new ABTest("showVideoInHome", 1, "Mostra vídeo institucional do Amigo Edu via Vimeo na home"),
	showClassTypeFilterOnHomeSearch: new ABTest("showClassTypeFilterOnHomeSearch", 0, "Mostrar filtro de modalidade na busca da Home"),
	requiredCourseFieldInHomepageSearch: new ABTest("requiredCourseFieldInHomepageSearch", 1, "Tornar campo de curso obrigatório na busca da Home"),
	showNewCitySelect: new ABTest("showNewCitySelect", 0, "Mostra campo com busca dinâmica de cidade no backend"),
	homeMediaSession: new ABTest("homeMediaSession", 0.2, "Amigo Edu na Mídia na Home"),
	howItWorks: new ABTest("howItWorks", 0.7, "Mostrar seção de como funciona na página de detalhes"),
	labelsInSearch: new ABTest("labelsInSearch", 1, "Mostrar labels paras os filtros de pesquisas de classes"),
	myInterests: new ABTest("myInterests", 1, "Meus Interesses"),
	newCheckoutMarketplaceDesign: new ABTest("newCheckoutMarketplaceDesign", 1, "Novo Design do fluxo dos Checkouts no Marketplace"),
	newMyAccountPage: new ABTest("newMyAccountPage", 1, "Nova página de Minha Conta"),
	newSearchEngine: new ABTest("newSearchEngine6", 0.3, "Novo motor de busca"),
	newVersionSearchCardEnem: new ABTest(
		"newVersionSearchCardEnem",
		1,
		"Mostrar apenas a melhor oferta na nova versão do card de resultados - Busca Nota",
	),
	numericKeyboardOnCheckout: new ABTest("numericKeyboardOnCheckout", 0.5, "Altera o tipo do teclado para númerico no checkout (apenas no mobile)"),
	pix: new ABTest("pix", 1, "Pagamento via PIX"),
	poll: new ABTest("poll", 0.5, "Enquete na página de oferta"),
	reclameAqui: new ABTest("reclameAqui", 1, "Reclame Aqui no banner da Home"),
	recommendations: new ABTest("recommendations", 0, "Recomendações na página de curso"),
	renderOfferPageForHiddenInstitutions: new ABTest("renderOfferPageForHiddenInstitutions", 0, "renderOfferPageForHiddenInstitutions"),
	score2: new ABTest("score2", 0.5, "Rankeamento probabilístico"),
	showContactPhoneNumber: new ABTest("showContactPhoneNumber", 0, "Exibir número de telefone para contato por ligação"),
	showBuscaNotaBanners: new ABTest("showBuscaNotaBanners", 0, "Exibir banners de promoção do busca-nota no marketplace"),
	scrollOnSearch: new ABTest("scrollOnSearch", 0.5, "Fazer scroll para resultados após a busca"),
	showCourseBadgeBenefits: new ABTest("showCourseBadgeBenefits", 1, "Mostrar os badges de benefícios da bolsa"),
	showDiscountLabel: new ABTest("showDiscountLabelV2", 0.5, "Label informando que desconto é até o final do curso"),
	showEnaeExamDate: new ABTest("showEnaeExamDate", 1, "Mostrar na primeira página data da prova ENAE"),
	showFaqEnae: new ABTest("showFaqEnae", 1, "Perguntas frequentes ENAE"),
	showLGPDCookiesModal: new ABTest("showLGPDCookiesModal2", 0.2, "LGPD (1ª Etapa): exibir modal de cookies"),
	showLGPDFirstStage: new ABTest(
		"showLGPDFirstStage2",
		0,
		"LGPD (1ª Etapa): flag de adesão à política de privacidade nas etapas de cadastro e checkout",
	),
	showMecScore: new ABTest("showMecScore", 0, "Mostrar nota do MEC na tela de detalhes"),
	showLaborMarketParagraph: new ABTest("showLaborMarketParagraph", 0.5, "Mostrar seção de mercado de trabalho na página de detalhes"),
	showNewIEPage: new ABTest("showNewIEPage", 0.3, "Mostra a nova página da IE"),
	signUpText: new ABTest("signUpText", 0.5, "Título da página de registro de usuário"),
	testAbPhonenumberBuscaNota: new ABTest("testAbPhonenumberBuscaNota", 0.75, "Pedir telefone como preenchimento opcional no fluxo do Busca Nota"),
	testAbTestSpliting: new ABTest("testAbTestSpliting", 0.5, "Teste de amostragem teste a/b"),
	topCoursesSelect: new ABTest("abTestCoursesSelect", 0.5, "Select - Recomendação cursos mais procurados"),
	whatsDialog: new ABTest("whatsDialog", 0, "Balão de diálogo no botão de whatsapp"),
	showTrustFooter: new ABTest("showTrustFooter", 0.5, "Novo footer de confiança"),
};

export const multiTests = {
	h1Home: new MultiTest("h1Home", ["Default", "Sonhos", "80%", "PagMenos"], "Headline home"),
	promotionBarWithTimerBuscaNota: new MultiTest(
		"promotionBarWithTimerBuscaNota",
		["Default", "ExpiresToday", "ExpiresInThreeDays"],
		"Promotion bar with countdown",
	),
};

export const isRenderOfferPageForHiddenInstitutions = () => {
	return abTests.renderOfferPageForHiddenInstitutions.isAvailable();
};

export const showTopCoursesSelect = () => {
	return abTests.topCoursesSelect.isAvailable();
};

export const isNewMyAccountPage = () => {
	return abTests.newMyAccountPage.isAvailable();
};

export const isGuaranteedChargebackOn = () => {
	return abTests.guaranteedChargeback.isAvailable();
};

export const isNewSearchEngineEnabled = () => {
	return abTests.newSearchEngine.isAvailable();
};

export const isScore2Enabled = () => {
	return abTests.score2.isAvailable();
};

export const isCanaryAPI = () => {
	return abTests.canaryAPI.isAvailable();
};

export const showContactPhoneNumber = () => {
	return abTests.showContactPhoneNumber.isAvailable();
};

export const showStudentPhoto = () => {
	return abTests.showStudentPhoto.isAvailable();
};

export const showVideoInHome = () => {
	return abTests.showVideoInHome.isAvailable();
};

export const isHomeMediaSession = () => {
	return abTests.homeMediaSession.isAvailable();
};

export const isHeadlineScholarshipDuration = () => {
	return abTests.headlineScholarshipDuration.isAvailable();
};
export const showBuscaNotaBanners = () => {
	return abTests.showBuscaNotaBanners.isAvailable();
};

export const isNewSignupText = () => {
	return abTests.signUpText.isAvailable();
};

export const showPix = () => {
	return abTests.pix.isAvailable();
};

export const showPoll = () => {
	return abTests.poll.isAvailable();
};

export const myInterests = () => {
	return abTests.myInterests.isAvailable();
};

export const showWhatsappDialog = () => {
	return abTests.whatsDialog.isAvailable();
};

export const enaeTestDay = () => {
	return abTests.enaeTestDay.isAvailable();
};

export const testAbCpVariant = (backCpVariant?: boolean | null) => {
	return backCpVariant !== null && backCpVariant !== undefined ? backCpVariant : abTests.testAbCpVariant.isAvailable();
};

export const showNewCheckoutMarketplaceDesign = () => {
	return abTests.newCheckoutMarketplaceDesign.isAvailable();
};

export const showRecommendations = () => {
	return abTests.recommendations.isAvailable();
};

export const hiddenCheckoutCouponField = () => {
	return abTests.checkoutCouponField.isAvailable();
};

export const showReclameAqui = () => {
	return abTests.reclameAqui.isAvailable();
};

export const showEnaeExamDate = () => {
	return abTests.showEnaeExamDate.isAvailable();
};

export const enaeDatesLayout = () => {
	return abTests.enaeDatesLayout.isAvailable();
};

export const showNewIEPage = () => {
	return abTests.showNewIEPage.isAvailable();
};

export const showNewEnaeHeadline = () => {
	return abTests.enaeHeadline.isAvailable();
};

export const showFaqEnae = () => {
	return abTests.showFaqEnae.isAvailable();
};

export const showLGPDCookiesModal = () => {
	return abTests.showLGPDCookiesModal.isAvailable();
};

export const showLGPDFirstStage = () => {
	return abTests.showLGPDFirstStage.isAvailable();
};

export const showCourseBadgeBenefits = () => {
	return abTests.showCourseBadgeBenefits.isAvailable();
};

export const showEnaeSimulado = () => {
	return abTests.enaeNewHeadlineSimulado.isAvailable();
};

export const enaePostTestDay = () => {
	return abTests.enaePostTestDay.isAvailable();
};

export const enaeResultDay = () => {
	return abTests.enaeResultDay.isAvailable();
};

export const scrollOnSearch = () => {
	return abTests.scrollOnSearch.isAvailable();
};

export const explainBenefitsCard = () => {
	return abTests.explainBenefitsCard.isAvailable();
};

export const showMecScore = () => {
	return abTests.showMecScore.isAvailable();
};

export const labelsInSearch = () => {
	return abTests.labelsInSearch.isAvailable();
};

export const testAbTestSplit = () => {
	return abTests.testAbTestSpliting.isAvailable();
};

export const testAbPhonenumberBuscaNota = () => {
	return abTests.testAbPhonenumberBuscaNota.isAvailable();
};

export const askWhenWantToJoinTheCourse = () => {
	return abTests.askWhenWantToJoinTheCourse.isAvailable();
};

export const newVersionSearchCardEnem = () => {
	return abTests.newVersionSearchCardEnem.isAvailable();
};

export const showDiscountLabel = () => {
	return abTests.showDiscountLabel.isAvailable();
};

export const showInstitutionFilterHome = () => {
	return abTests.showInstitutionFilterHome.isAvailable();
};

export const showHowItWorks = () => {
	return abTests.howItWorks.isAvailable();
};

export const numericKeyboardOnCheckout = () => {
	return abTests.numericKeyboardOnCheckout.isAvailable();
};

export const showLaborMarketParagraph = () => {
	return abTests.showLaborMarketParagraph.isAvailable();
};

export const isClassTypeFilterOnHomeSearchAvailable = () => {
	return abTests.showClassTypeFilterOnHomeSearch.isAvailable();
};

export const requiredCourseFieldInHomepageSearch = () => {
	return abTests.requiredCourseFieldInHomepageSearch.isAvailable();
};

export const showNewCitySelect = () => {
	return abTests.showNewCitySelect.isAvailable();
};

export const setABTestsToAmplitude = (amplitudeInstance: AmplitudeClient) => {
	amplitudeInstance.setUserProperties({
		abTestAPIEndpoint: isCanaryAPI() ? "Canary" : "Main",
		abTestAskWhenWantToJoinTheCourse: askWhenWantToJoinTheCourse() ? "Ask" : "DontAsk",
		abTestCheckoutCouponField: hiddenCheckoutCouponField() ? "HiddenCheckoutField" : "NotHidden",
		abTestENAEHeadline: showNewEnaeHeadline() ? "New" : "Old",
		abTestEnaeDatesLayout: enaeDatesLayout() ? "New" : "Old",
		abTestExplainBenefitsCard: explainBenefitsCard() ? "Show" : "DontShow",
		abTestHowItWorks: showHowItWorks() ? "Show" : "DontShow",
		abTestMediaSession: isHomeMediaSession() ? "NewMediaSession" : "OldMediaSession",
		abTestMyAccountPage: isNewMyAccountPage() ? "NewMyAccountPage" : "OldMyAccountPagePage",
		abTestMyInterests: myInterests() ? "MyInterests" : "NoneMyInterests",
		abTestNewSearchEngineV6: isNewSearchEngineEnabled() ? "New" : "Old",
		abTestNewSignupText: isNewSignupText() ? "New" : "Old",
		abTestNewVersionSearchCardEnem: newVersionSearchCardEnem() ? "New" : "Old",
		abTestNumericKeyboardOnCheckout: numericKeyboardOnCheckout() ? "Show" : "Dont Show",
		abTestPhonenumberBuscaNota: testAbPhonenumberBuscaNota() ? "Show" : "DontShow",
		abTestRanking: isScore2Enabled() ? "Score2" : "Score1",
		abTestReclameAqui: showReclameAqui() ? "ReclameAqui" : "DontShowReclameAqui",
		abTestRecommendations: showRecommendations() ? "RecommendationsShown" : "NoRecommendations",
		abTestScrollOnSearch: scrollOnSearch() ? "Scroll" : "DontScroll",
		abTestShowCourseBadgeBenefitsV2: showCourseBadgeBenefits() ? "Show" : "DontShow",
		abTestShowDiscountLabelV2: showDiscountLabel() ? "Show" : "DontShow",
		abTestShowEnaeExamDate: showEnaeExamDate() ? "ShowExamDate" : "DontShow",
		abTestShowFaqEnae: showFaqEnae() ? "Show" : "DontShow",
		abTestShowLGPDCookiesModal: showLGPDCookiesModal() ? "Show" : "DontShow",
		abTestShowLGPDFirstStage: showLGPDFirstStage() ? "Show" : "DontShow",
		abTestShowMecScore: showMecScore() ? "Show" : "DontShow",
		abTestShowLaborMarketParagraph: showLaborMarketParagraph() ? "Show" : "DontShow",
		abTestShowNewIEPage: showNewIEPage() ? "New" : "Old",
		abTestShowPoll: showPoll() ? "PollShown" : "NoPoll",
		abTestSplitTest: testAbTestSplit() ? "B" : "A",
		abTestTopCoursesSelect: showTopCoursesSelect() ? "Show" : "DontShow",
		abTestWhatsappDialog: showWhatsappDialog() ? "Dialog" : "None",
		multiTestH1Home: multiTests.h1Home.variants[multiTests.h1Home.getVariant()],
		multiTestPromotionBarWithTimerBuscaNota:
			multiTests.promotionBarWithTimerBuscaNota.variants[multiTests.promotionBarWithTimerBuscaNota.getVariant()],
		showEnaeSimulado: showEnaeSimulado() ? "New" : "Old",
	});
};

export const showTrustFooter = () => {
	return abTests.showTrustFooter.isAvailable();
};
